<template lang="pug">
//-nuxt-link.gu24__logo(to="/", :title="$t('msgs.toMain')")
a.gu24__logo(:href="`https://24guru.by/${$i18n.locale}`", :title="$t('msgs.toMain')")
  .gu24__logo__image
</template>

<script>
export default {
  name: 'AfishaLogo',
};
</script>

<style lang="scss" src="./_.scss"></style>

<style lang="scss">
.white .gu24__logo__image { background-image: url('./images/white/24guru.svg') }
.gu24__logo__image { background-image: url('./images/dark/24guru.svg') }
</style>
